<template src="./template/index.html"></template>
<script>
import DibbleTranslation from "../../../translation/translation";
import DibbleJS from "../../../dibble";
import DibbleApi from "../../../api";
import Datepicker from "vuejs-datepicker";
import ModalSlipInfo from "../SlipInfoModal";
import DibbleAPI from "../../../api";
import Pagination from "@/commons/pagination/Pagination.vue";

export default {
    name: "MoorageSlips",
    components: {Pagination, Datepicker, ModalSlipInfo },
    data() {
        return {
            router: this.$router,
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            id: this.$route.params.id,
            originSlips: [],
            slips: [],
            isDateFilter: false,
            startDate: null,
            endDate: null,
            filter_boat_type: '',
            boatTypes: {
                1: 'Deck Boat',
                2: 'House Boat',
                3: 'Cabin Cruiser Boat',
                4: 'Sail Boat',
                5: 'Pontoon Boat'
            },
            slipStatuses: [],
            filter_boat_length: 0,
            filter_has_cover: '-1',
            filter_has_cover_list: {
                '-1': 'N/A',
                '0': 'No',
                '1': 'Yes'
            },
            filter_close_to_patio: '-1',
            filter_close_to_patio_list: {
                '-1': 'N/A',
                '0': 'No',
                '1': 'Yes'
            },
            modalInfo: null,
            isShow: false,
            curentPage: 1,
            totalPage: 1,
            searchingText: '',
        }
    },
    created() {
        this.getAllSlips()
    },
    watch: {
      searchingText: function (val) {
        if (val) {
          this.slips = this.originSlips.filter((slip) => {
            return slip.slip_name.toLowerCase().includes(val.toLowerCase());
          });
        } else {
          this.slips = this.originSlips;
        }
      },
    },
    methods: {
        onClickPagging(params) {
            this.getAllSlips(params.pageIndex - 1);
        },
        getAllSlips(page = 0) {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getMarinaSlips,
                marina_id: this.$route.params.id,
                start_date: (this.isDateFilter && this.formatDatetimeOutputForApi(this.startDate)) || "",
                end_date: (this.isDateFilter && this.formatDatetimeOutputForApi(this.endDate)) || "",
                boat_type: this.filter_boat_type,
                filter_boat_length: this.filter_boat_length,
                filter_has_cover: this.filter_has_cover,
                filter_close_to_patio: this.filter_close_to_patio,
                page
            };

            this.curentPage = page;
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        filterBoatType(type) {
            this.filter_boat_type = type;
            this.getAllSlips();
        },
        filterHasCover(type) {
            this.filter_has_cover = type;
            this.getAllSlips();
        },
        filterCloseToPatio(type) {
            this.filter_close_to_patio = type;
            this.getAllSlips();
        },
        filterByDate(set) {
            this.isDateFilter = set;
            this.getAllSlips();
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                const { slips, map_statuses, num_of_pages } = response;
                this.totalPage = num_of_pages || 1;
                this.originSlips = this.slips = slips || [];
                this.slipStatuses = map_statuses
            }
        },
        getSlipInfo(slipName) {
            DibbleJS.showLoader();
            const params = {
                request: DibbleAPI.api.getSlipInfoByName,
                marina_id: this.id,
                slip_name: slipName,
            };
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.modalInfo = responseData;
                    this.isShow = true;
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            });
        },
        closeModal() {
            this.isShow = false;
        },
        formatDatetimeOutputForApi(m) {
            return this.$moment(m).format("YYYY-MM-DD") + " 00:00:00";
        },
    }
}
</script>

<style lang="scss" scoped>
tr.order-row {
    cursor: pointer;
}

tr.order-row:hover {
    background-color: #e1e1e1;
}

.order-history {
    display: flex;
    width: 100%;
    padding: 20px 30px;
    min-width: 1000px;
    align-items: flex-start;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .table-order {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-self: stretch;

        .header-boat-info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-boat {
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: capitalize;
                color: #1C5169;
                font-size: 22px;
            }

            .toggle-button {
                width: 220px;
                background: #dfdfdf;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                opacity: 0.8;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 30px;
                height: 60px;

                >div {
                    width: calc(100%/3);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-sizing: border-box;

                    &:not(:last-child) {
                        border-right: 1.5px solid #fff;
                    }

                }

                p {
                    font-weight: 600;
                    font-size: 18px;
                    color: #7C7C7A;
                }

                .active-button {
                    p {
                        color: #2C94AB;
                    }

                    background: #D9D9D9 !important;
                    border-top-right-radius: 30px;
                    border-bottom-right-radius: 30px;
                }
            }
        }
    }

    .sidebar-filter {
        width: 20%;
        margin-left: 5%;
        background: #E8EFF1;
        border-radius: 40px;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;

        .header-filter {
            padding: 10px 0px;

            p {
                font-weight: 600;
                font-size: 22px;
                color: #1C5169;
            }
        }

        .line-through {
            height: 1.5px;
            background: #DEE6EA;
            width: calc(100% + 40px);
            margin-left: -20px;
        }

        .boat-no {
            .title {
                font-weight: 700;
                font-size: 16px;
                letter-spacing: 0.04em;
                color: #1C5169;
            }

            .list-no {
                margin-left: -3px;

                button {
                    background: #C2D8DD;
                    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                    border-radius: 20px;
                    border: none;
                    margin: 3px;
                    display: inline-block;
                }

                .active {
                    background: #2C94AB;

                    p {
                        color: #FFFFFF;

                    }
                }

                p {
                    font-weight: 600;
                    font-size: 16px;
                    color: #7C7C7A;
                    padding: 5px 10px;
                    text-align: center;
                }
            }

            .list-select-date {
                display: flex;
                justify-content: space-between;

                .select-date {
                    background: #FFFFFF;
                    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                    border-radius: 20px;
                    padding: 5px 10px;
                    width: 48%;

                    label {
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 10px;
                        color: #7C7C7A;
                        margin: 0;
                    }
                }

                .input-date {
                    border: 0 !important;
                }
            }
        }

        .button-scan-qr {
            display: flex;
            justify-content: flex-end;
            margin: 20px 10px;
            flex: 1;
            flex-direction: column;
            align-items: center;

            button {
                background: #1C5169;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 100px;
                border: none;
                margin-top: 20px;
                width: max-content;
            }

            p {
                font-weight: 600;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                padding: 10px 20px;
            }
        }
    }

}

@media only screen and (max-width: 1250px) {
    .list-select-date {
        display: flex;
        flex-direction: column !important;
    }

    .select-date {
        width: 100% !important;

        &:nth-child(2) {
            margin-top: 10px;
        }
    }

    .button-scan-qr {
        p {
            font-size: 16px !important;
            padding: 10px 10px !important;
        }
    }

}
</style>
